<template>
  <v-text-field
    v-model="search"
    background-color="cardSurface"
    solo
    :label="label"
    prepend-inner-icon="mdi-magnify"
    hide-details
    clearable
  >
  </v-text-field>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  props: {
    value: {
      type: String,
    },
    label: {
      type: String,
      default: "Søk ...",
    },
  },

  computed: {
    search: {
      get(): string {
        return this.value;
      },
      set(value: string) {
        this.$emit("input", value);
      },
    },
  },
});
</script>
